<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<defs></defs>
		<g transform="translate(-1467.75 -539)">
			<path
				d="M8.644,8.59l8.606,8.588L25.856,8.59,28.5,11.234,17.25,22.484,6,11.234Z"
				transform="translate(1473 546.516)"
			/>
			<path class="a" d="M0,0H45V45H0Z" transform="translate(1467.75 539)" />
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-chevron-down',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
  path.a {
    fill: none;
  }
</style>

<docs>
    IconChevronDown

    ```js
    <b-icon-chevron-down />
    ```
</docs>
